

























import $ from 'jquery';
/* eslint @typescript-eslint/camelcase: 0 */
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { DynamicFormItemModel, TokenModel } from '@/helpers/Interfaces';
import StorageService from '@/services/core/StorageService';
import DynamicFormsService from '@/services/core/DynamicFormsService';
import TagsService from '@/services/cms/TagsService';
import { baseurl } from '@/helpers/Utils';
import merge from 'lodash/merge';
import head from 'lodash/head';
import { FormType } from './forms/types/Form';

@Component({
    name: 'editor'
})
export default class Editor extends Vue
{
    @Prop() public id!: string;
    @Prop({default: ''}) value: string;
    @Prop({default: () => [
        'print preview fullpage powerpaste searchreplace autolink directionality advcode visualblocks visualchars casechange autoresize',
        'fullscreen image link media template codesample table advtable charmap hr pagebreak nonbreaking anchor toc insertdatetime pageembed',
        'advlist lists textcolor wordcount imagetools mediaembed contextmenu colorpicker textpattern help',
        'mention tokens tag insertform forms quickbars'
    ]}) plugins: string[];
    @Prop({
        default: 'file edit view insert format table tools help'
    }) menubar: string;
    @Prop({
        default: 'undo redo | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | image link anchor media pastetext pageembed charmap emoticons forms | template preview fullscreen code'
    }) toolbar1: string;
    @Prop({default: 'fontselect fontsizeselect formatselect | spellchecker language spellcheckdialog | forecolor backcolor codesample | pagebreak '}) toolbar2: string;
    @Prop({default: 'link linkchecker | cut paste copy image | imagetools editimage table spellchecker lists configurepermanentpen'}) contextmenu: string;
    @Prop({default: 'fontselect fontsizeselect formatselect | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | forecolor backcolor casechange'}) quickbarsSelectionToolbar: string;
    @Prop({default: false}) quickbarsInsertToolbar: boolean;
    @Prop({default: 'alignleft aligncenter alignright'}) quickbarsImageToolbar: string;
    @Prop({default: 500}) minHeight: number;
    @Prop({default: () => {}}) editorOptions: object;
    @Prop({default: (): TokenModel[] => []}) tokens: TokenModel[];
    @Prop({default: null}) blueprint: FormType;
    @Prop({default: false}) tokensEnabled: boolean;
    @Prop({default: false}) tagsEnabled: boolean;
    @Prop({default: false}) formsEnabled: boolean;
    @Prop({default: false}) disabled: boolean;
    @Prop({default: 'ertvrmcid3bvlesiyxdckxk4cwon3xy9m52v35debic6ls87'}) apiKey: string;

    public loading: boolean = false;
    public scriptLoaded: boolean = false;
    public editor: any = null;
    public content: string = '';
    public fileModal: boolean = false;
    public formModal: boolean = false;
    public media: string = "*";
    public forms: DynamicFormItemModel[] = [];
    public tags: string[] = [];
    public filemanager: any = {
        callback: null,
        value: null,
        meta: null
    };

    get selector(): string
    {
        return '#' + this.id;
    }

    get global(): any
    {
        return (typeof window !== 'undefined' ? window : global);
    }

    get tinymce(): any
    {
        const global = this.global;
        return global && global.tinymce ? global.tinymce : null;
    }

    async created(): Promise<void>
    {
        this.loading = true;
        await this.initScripts();
    }

    mounted(): void
    {
        this.$events.$on('editor::reinit', this.reinit);
        this.$events.$on('filemanager::modal::close', this.closeFileModal);
        this.$events.$on('filemanager::callback::value', this.callbackValue);

        this.init();
    }

    destroyed(): void
    {
        this.remove();

        this.$events.$off('editor::reinit', this.reinit);
        this.$events.$off('filemanager::modal::close');
        this.$events.$off('filemanager::callback::value');
    }

    settings(): any
    {
        const ctx = this;

        const updateImage = (el: any): void =>
        {
            const src = el.attr('src');

            if (src.indexOf('#(storage):') == 0)
            {
                const publicId = src.replace('#(storage):', '');

                el.attr('src', StorageService.previewResource(publicId));
                el.attr('data-src', src);
            }
            else if(src.indexOf('#(image):') == 0)
            {
                const publicId = src.replace('#(image):', '');

                el.attr('src', StorageService.previewResource(publicId));
                el.attr('data-src', src);
            }
        };

        const displayImages = (editor: any, content: string): string =>
        {
            const html = editor.$('<div></div>').html(content);

            html.find('img').toArray().forEach((img: any) =>
            {
                updateImage(editor.$(img));
            });

            return html.html();
        };

        const serializeImages = (editor: any, content: string): string =>
        {
            // Zablokowanie doczytywania obrazkow przez parser jquery
            content = content.replace(new RegExp(' src="', 'g'), ' src-disabled="');

            const html = editor.$('<div></div>').html(content);

            html.find('img').toArray().forEach((img: any) =>
            {
                const el = editor.$(img);
                const src = el.attr('data-src');

                if (src && src.indexOf('#(storage):') == 0)
                {
                    el.attr('src-disabled', src);
                    el.removeAttr('data-src');
                }
                else if (src && src.indexOf('#(image):') == 0)
                {
                    el.attr('src-disabled', src);
                    el.removeAttr('data-src');
                }
            });

            // Przywrocenie oryginalnego kodu html
            return html.html().replace(new RegExp(' src-disabled="', 'g'), ' src="');
        };

        const options = {
            selector: '#' + this.id,
            language: ctx.$i18n.shortLocale(),
            skin_url: '/static/skins/oxide',
            content_css_cors: false,
            content_css: [
                '/static/skins/oxide/content.min.css',
                '//www.tinymce.com/css/codepen.min.css'
            ],
            mobile: {
                theme: 'silver'
            },
            toolbar_mode: 'sliding',
            toolbar: [
                this.toolbar1,
                this.toolbar2
            ],
            menubar: this.menubar,
            menu:
            {
                tokens: { title: 'Tokeny', items: 'tokens | remove-token' },
                forms: { title: 'Formularze', items: 'forms | deleteform' }
            },
            plugins: this.plugins,
            templates: this.templates(),
            contextmenu: this.contextmenu,
            quickbars_selection_toolbar: this.quickbarsSelectionToolbar,
            quickbars_insert_toolbar: this.quickbarsInsertToolbar,
            quickbars_image_toolbar: this.quickbarsImageToolbar,
            tokens: this.tokens,
            forms: this.forms,
            relative_urls: false,
            paste_data_images: false,
            browser_spellcheck: true,
            entity_encoding: "raw",
            min_height: this.minHeight,
            autoresize_bottom_margin: 50,
            nowrap: false,
            resize: false,
            link_context_toolbar: true,
            link_default_protocol: 'https',
            link_class_list: [
                {title: this.$t('[[[Brak]]]'), value: ''},
                {title: this.$t('[[[Link wewnętrzny]]]'), value: 'int_link'},
                {title: this.$t('[[[Link zewnętrzny]]]'), value: 'ext_link'},
            ],
            target_list: [
                {title: this.$t('[[[Brak]]]'), value: ''},
                {title: this.$t('[[[Obecna]]]'), value: '_self'},
                {title: this.$t('[[[Nowa strona]]]'), value: '_blank'}
            ],
            spellchecker_active: true,
            spellchecker_language: 'pl',
            spellchecker_languages: 'Polski=pl',
            content_langs: [
                { title: 'Polski', code: 'pl' }
            ],
            paste_postprocess: (plugin: any, args: any) =>
            {
                try
                {
                    const el = args.node.firstChild;
                    if(el instanceof HTMLElement)
                    {
                        const type = el.getAttribute('data-type');
                        const id = el.getAttribute('data-id');

                        switch (type)
                        {
                            case "image":
                                el.setAttribute('src', StorageService.previewResource(id));
                                el.setAttribute('data-src', `#(image):${id}`);
                                break;
                            case "media":
                                el.setAttribute('href', `#(storage):${id}`);
                                break;
                            case "file":
                                el.setAttribute('href', `#(storage):${id}`);
                                break;
                            case "form":
                                el.setAttribute('href', `#(form):${id}`);
                                break;
                            default:
                                break;
                        }
                    }
                }
                catch(ex)
                {
                    this.$log.error(ex);
                }
            },
            powerpaste_word_import: () => ctx.showPowerPasteQuestion(),
            powerpaste_googledocs_imports: () => ctx.showPowerPasteQuestion(),
            table_style_by_css: true,
            table_sizing_mode: 'relative',
            media_alt_source: false,
            media_poster: false,
            image_advtab: true,
            images_replace_blob_uris: true,
            images_reuse_filename : false,
            automatic_uploads: true,
            style_formats: [
                {
                    title: 'Image Left',
                    selector: 'img',
                    styles: {
                        'float': 'left',
                        'margin': '0 10px 0 10px'
                    }
                },
                {
                    title: 'Image Right',
                    selector: 'img',
                    styles: {
                        'float': 'right',
                        'margin': '0 0 10px 10px'
                    }
                }
            ],
            insert_form_callback: (callback: any, value: any) =>
            {
                ctx.$emit('insertForm', value);
            },
            file_picker_callback: (callback: any, value: any, meta: any) =>
            {
                $('.tox-tinymce-aux').hide();

                ctx.fileModal = true;
                ctx.filemanager.callback = callback;
                ctx.filemanager.value = value;
                ctx.filemanager.meta = meta;

                switch (meta.filetype)
                {
                    case "image":
                        ctx.media = "image";
                        break;
                    case "media":
                        ctx.media = "media";
                        break;
                    case "file":
                        ctx.media = "all";
                        break;
                    default:
                        ctx.media = "all";
                        break;
                }
            },
            images_upload_handler: (blobInfo: any, progress: any) =>
            {
                return this.sendRequest(blobInfo);
            },
            mentions: {
                delimiter: '{',
                enabled: this.tokens.length > 0,
                source: this.tokens,
                render: function(item: any)
                {
                    return '<li><a href="javascript:;"><strong>{{' + item.key + '}}</strong> - <span>' + item.name + '</span></a></li>';
                },
                insert: function(item: any)
                {
                    return '<span>{{' + item.key + '}}</span>';
                }
            },
            tags: {
                delimiter: '#',
                enabled: this.tags.length > 0,
                source: this.tags,
                render: function(item: any)
                {
                    return '<li><a href="javascript:;"><span>#' + item + '</span></a></li>';
                },
                insert: function(item: any)
                {
                    return `<a href="#(tag):${item.key}">#` + item.key + '</a>';
                }
            },
            setup: (editor: any) =>
            {
                ctx.editor = editor;
                editor.on('init', (e: Event) =>
                {
                    ctx.content = this.value || '';
                    editor.setContent(ctx.content);
                });
                editor.on('change keyup undo redo', () =>
                {
                    ctx.content = serializeImages(editor, editor.getContent());
                    ctx.$emit('input', ctx.content);
                });
                editor.on('BeforeSetContent', (e: any) =>
                {
                    if (e.content)
                    {
                        e.content = displayImages(editor, e.content);
                    }
                });
                editor.on('PostProcess', (e: any) =>
                {
                    if (e.content && e.source_view)
                    {
                        e.content = serializeImages(editor, e.content);
                    }
                    if (e.content && !e.source_view)
                    {
                        e.content = displayImages(editor, e.content);
                    }
                });
                editor.on('NodeChange', (e: any) =>
                {
                    if (e.element && e.element.tagName == "IMG")
                    {
                        const el = editor.$(e.element);
                        const src = el.attr('src');

                        if (src.startsWith('#(storage):'))
                        {
                            updateImage(editor.$(e.element));
                        }
                    }
                });
                editor.on('OpenWindow', (e: any) =>
                {
                    const data = e.dialog.getData();

                    // Image
                    if (data?.src?.value?.length > 0 && data?.src?.value.startsWith(baseurl()))
                    {
                        e.dialog.setData({
                            src: {
                                value: `#(image):${data.src.value.split('/').pop()}`
                            }
                        });
                    }
                });
            }
        };

        return merge(options, this.editorOptions);
    }

    async loadForms(): Promise<boolean>
    {
        try
        {
            if(this.formsEnabled)
            {
                this.forms = await DynamicFormsService.getOptions();
            }

            return true;
        }
        catch (ex)
        {
            this.handleException(ex, {
                400: (ex: any) => this.$a.warning(ex.message),
                403: (ex: any) => this.$a.warning(ex.message)
            });

            return false;
        }
    }

    async loadTags(): Promise<boolean>
    {
        try
        {
            if(this.tagsEnabled)
            {
                this.tags = await TagsService.getAll();
            }

            return true;
        }
        catch (ex)
        {
            this.handleException(ex, {
                400: (ex: any) => this.$a.warning(ex.message),
                403: (ex: any) => this.$a.warning(ex.message)
            });

            return false;
        }
    }

    sendRequest(blobInfo: any): Promise<any>
    {
        const editor = this.editor;
        const blobUri = blobInfo.blobUri();

        return new Promise((resolve, reject) =>
        {
            const formData = new FormData();
            const req = new XMLHttpRequest();

            formData.append('file', blobInfo.blob(), blobInfo.filename());
            formData.append('scope', 'upload');
            formData.append('secure', 'false');

            req.onload = () =>
            {
                if (req.status === 403)
                {
                    reject({ message: 'HTTP Error: ' + req.status, remove: true });
                    return;
                }

                if (req.status < 200 || req.status >= 300)
                {
                    reject('HTTP Error: ' + req.status);
                    return;
                }

                const json = JSON.parse(req.responseText);

                if (!json)
                {
                    reject('Invalid JSON: ' + req.responseText);
                    return;
                }

                editor.$(`img[src="${blobUri}"]`).attr({
                    'src': StorageService.previewResource(json.publicId),
                    'data-mce-src': StorageService.previewResource(json.publicId),
                    'data-src': `#(image):${json.publicId}`
                });

                resolve({
                    status: req.status,
                    url: `#(image):${json.publicId}`
                });
            };

            req.onreadystatechange = () =>
            {
                if (req.readyState === XMLHttpRequest.DONE)
                {
                    if (req.status === 200)
                    {
                        resolve(JSON.parse(req.responseText));
                    }
                    else
                    {
                        reject(JSON.parse(req.responseText));
                    }
                }
            };

            req.open('POST', StorageService.uploadUrl());
            req.setRequestHeader('Authorization', 'Bearer ' + this.$auth.token());
            req.send(formData);
        });
    }

    callbackValue(files: any[]): void
    {
        if (this.fileModal === true)
        {
            const file = head(files);
            const params = this.filemanager;

            if (file)
            {
                const size = this.$options.filters.filesize(file.contentLength);
                const text = `${file.name} [${size}]`;

                if (params.meta.filetype === 'file')
                {
                    const url = `#(storage):${file.publicId}`;
                    params.callback(url, { text: params.meta.text || text, title: file.name });
                }
                if (params.meta.filetype === 'image')
                {
                    const url = `#(image):${file.publicId}`;
                    params.callback(url, { alt: file.name, width: file.meta.width, height: file.meta.height });
                }
                if (params.meta.filetype === 'media')
                {
                    const url = `#(storage):${file.publicId}`;
                    params.callback(url, { width: 480, height: 270 });
                }
            }

            this.closeFileModal();
        }
    }

    closeFileModal(): void
    {
        $('.tox-tinymce-aux').show();
        this.fileModal = false;
    }

    async initScripts(): Promise<void>
    {
        if(this.disabled) return;

        if(document.getElementById("tinymce-script"))
        {
            await this.onScriptLoaded();
        }
        else
        {
            const tag = document.createElement("script");
            tag.setAttribute("id", "tinymce-script");
            tag.setAttribute("type", "application/javascript");
            tag.setAttribute("src", `https://cdn.tiny.cloud/1/${this.apiKey}/tinymce/5/tinymce.min.js`);
            tag.setAttribute("referrerpolicy", "origin");
            tag.addEventListener('load', this.onScriptLoaded);
            document.head.appendChild(tag);
        }
    }

    showPowerPasteQuestion(): Promise<string>
    {
        return this.$confirm(
            this.$t("[[[Wybierz opcję zachowywania lub usuwania formatowania we wklejanej treści.]]]"),
            this.$t('[[[Wklej opcje formatowania]]]'),
            {
                confirmButtonText: this.$t('[[[Zachowaj formatowanie]]]'),
                cancelButtonText: this.$t('[[[Usuń formatowanie]]]'),
                showClose: false,
                center: true,
                type: 'info'
            }
        ).then(() => 'merge')
            .catch(() => 'clean');
    }

    initPlugins(): void
    {
        import(/* webpackChunkName: "components" */'@/components/tinymce/Tinymce.vue');
    }

    init(): void
    {
        if(!this.scriptLoaded) return;

        if (this.tinymce)
        {
            this.tinymce.init(this.settings());
        }
    }

    reinit(): void
    {
        if(!this.scriptLoaded) return;

        if (this.editor)
        {
            this.tinymce.remove(this.editor);
        }

        this.tinymce.init(this.settings());
    }

    remove(): void
    {
        if(!this.scriptLoaded) return;

        if (this.tinymce)
        {
            this.tinymce.remove(this.editor);
        }
    }

    async onScriptLoaded(): Promise<void>
    {
        this.scriptLoaded = true;
        this.initPlugins();

        const promises = [];
        promises.push(this.loadForms());
        promises.push(this.loadTags());

        await Promise.all(promises);

        this.loading = false;
        this.reinit();
    }

    @Watch('value')
    onValueChanged(value: string, old: string): void
    {
        if (this.editor && value !== this.content && value !== old)
        {
            this.editor.setContent(value);
            this.content = value;
        }
    }

    @Watch('forms')
    onFormsChanged(value: DynamicFormItemModel[], old: DynamicFormItemModel[]): void
    {
        if(!this.loading)
        {
            this.reinit();
        }
    }

    @Watch('tokens')
    onTokensChanged(value: TokenModel[], old: TokenModel[]): void
    {
        if(!this.loading)
        {
            this.reinit();
        }
    }

    @Watch('tags')
    onTagsChanged(value: string[], old: string[]): void
    {
        if(!this.loading)
        {
            this.reinit();
        }
    }

    templates(): any[]
    {
        return [
            {
                title: '1/2',
                description: this.$t('[[[Wstaw dwie równe kolumny]]]'),
                content: `
                    <div class="row">
                        <div class="medium-6 small-12 column edito-column">
                            &nbsp;Lorem ipsum...
                        </div>
                        <div class="medium-6 small-12 column edito-column">
                            &nbsp;Lorem ipsum...
                        </div>
                    </div>
                    <p></p>
                `
            },
            {
                title: '2/3 - 1/3',
                description: this.$t('[[[Wstaw dwie kolumny 2/3 oraz 1/3]]]'),
                content: `
                    <div class="row">
                        <div class="medium-8 small-12 column edito-column">
                            &nbsp;Lorem ipsum...
                        </div>
                        <div class="medium-4 small-12 column edito-column">
                            &nbsp;Lorem ipsum...
                        </div>
                    </div>
                    <p></p>
                `
            },
            {
                title: '1/3',
                description: this.$t('[[[Wstaw trzy kolumny 1/3]]]'),
                content: `
                    <div class="row">
                        <div class="medium-4 small-12 column edito-column">
                            &nbsp;Lorem ipsum...
                        </div>
                        <div class="medium-4 small-12 column edito-column">
                            &nbsp;Lorem ipsum...
                        </div>
                        <div class="medium-4 small-12 column edito-column">
                            &nbsp;Lorem ipsum...
                        </div>
                    </div>
                    <p></p>
                `
            },
            {
                title: '1/4',
                description: this.$t('[[[Wstaw cztery kolumny 1/4]]]'),
                content: `
                    <div class="row">
                        <div class="medium-3 small-12 column edito-column">
                            &nbsp;Lorem ipsum...
                        </div>
                        <div class="medium-3 small-12 column edito-column">
                            &nbsp;Lorem ipsum...
                        </div>
                        <div class="medium-3 small-12 column edito-column">
                            &nbsp;Lorem ipsum...
                        </div>
                        <div class="medium-3 small-12 column edito-column">
                            &nbsp;Lorem ipsum...
                        </div>
                    </div>
                    <p></p>
                `
            },
            {
                title: '1/3 - 2/3',
                description: this.$t('[[[Wstaw dwie kolumny 1/3 oraz 2/3]]]'),
                content: `
                    <div class="row">
                        <div class="medium-4 small-12 column edito-column">
                            &nbsp;Lorem ipsum...
                        </div>
                        <div class="medium-8 small-12 column edito-column">
                            &nbsp;Lorem ipsum...
                        </div>
                    </div>
                    <p></p>
                `
            },
            {
                title: this.$t('[[[Ważne informacje]]]'),
                description: this.$t('[[[Wstaw szablon informacyjny ze zdjęciem]]]'),
                content: `
                    <div class="row custom-template" data-equalizer="column">
                        <div class="medium-3 small-5 column image-template" data-equalizer-watch="column">
                            <img src="/static/img/Lewiatan-logo.png">
                        </div>
                        <div class="medium-9 small-7 column desc" data-equalizer-watch="column">
                            &nbsp;Treść komunikatu
                        </div>
                    </div>
                    <p></p>
                `
            }
        ];
    }

    isNode(o: any): boolean
    {
        return (
            typeof Node === "object" ? o instanceof Node :
                o && typeof o === "object" && typeof o.nodeType === "number" && typeof o.nodeName==="string"
        );
    }

    isElement(o: any): boolean
    {
        return (
            typeof HTMLElement === "object" ? o instanceof HTMLElement : //DOM2
                o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName==="string"
        );
    }
}
